export default "__VITE_ASSET__190b91b2__"